"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var drive_types_1 = require("../../../common/types/drive.types");
var instructor_cancel_drive_controller_1 = __importDefault(require("./instructor-cancel-drive.controller"));
var instructor_cancel_drive_html_1 = __importDefault(require("./instructor-cancel-drive.html"));
function getDrive($stateParams, DrivesModel) {
    return DrivesModel.getDriveByID($stateParams.driveId).then(function (response) {
        var drive = response.drive;
        if (response.drive.status !== "Available" &&
            response.drive.observation === false) {
            if (drive.student_id !== null) {
                var hasGuardian = drive.student.usermeta.filter(function (meta) {
                    return meta.meta_key === "guardian";
                });
                var parentMeta = void 0;
                if (hasGuardian.length === 1) {
                    parentMeta = hasGuardian[0].meta_value;
                    drive.student.guardian = JSON.parse(parentMeta);
                }
                drive.student.phone = drive.student.usermeta.filter(function (meta) {
                    return meta.meta_key === "phone";
                })[0].meta_value;
            }
        }
        if (response.drive.status !== "Available" &&
            response.drive.observation === true) {
            response.drive.students = response.drive.students.map(function (student) {
                var hasGuardian = student.usermeta.filter(function (meta) {
                    return meta.meta_key === "guardian";
                });
                var parentMeta;
                if (hasGuardian.length === 1) {
                    parentMeta = hasGuardian[0].meta_value;
                    student.guardian = JSON.parse(parentMeta);
                }
                student.phone = student.usermeta.filter(function (meta) {
                    return meta.meta_key === "phone";
                })[0].meta_value;
                return student;
            });
        }
        Object.assign(drive, (0, drive_types_1.formatDriveForDisplay)(drive));
        return drive;
    });
}
getDrive.$inject = ["$stateParams", "DrivesModel"];
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.instructor.dashboard.canceldrive", {
        url: "/:driveId/cancel",
        controller: instructor_cancel_drive_controller_1.default,
        resolve: {
            driveSession: getDrive,
        },
        controllerAs: "vm",
        template: instructor_cancel_drive_html_1.default,
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.owner,
                USER_ROLES.instructor,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
exports.default = angular_1.default
    .module("instructor.dashboard.canceldrive", [])
    .config(config)
    .controller("InstructorCancelDriveController", instructor_cancel_drive_controller_1.default);
